import { BASE_URL } from "@/constants/endpoints";
import { CBUEntity } from "@/mocks/cbu.mock";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

export interface GetCBUListProps {
  busqueda?: string;
  tipoCuenta?: number;
  "P.Pagina"?: number;
  "P.Records"?: number;
}

export interface GetCBUListResponse {
  listado: CBUEntity[];
  totalPages: number;
  totalRecords: number;
}

let cbuApiPromise: Promise<AxiosInstance> | null = null;
export const getCbuApi = async () => {
  if (cbuApiPromise) return cbuApiPromise;

  cbuApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return cbuApiPromise;
};

export const getCBUList = async (
  props: GetCBUListProps,
): Promise<GetCBUListResponse | null> => {
  const api = await getCbuApi();
  if (!api) return null;
  const response = await api.get(
    `/Cbu/GetListadoCbus?${objectToQueryStringWithArray(props)}`,
  );

  return response?.data;
};
